import { jsx as r } from "react/jsx-runtime";
import { useContext as d } from "react";
import { cn as i } from "./designsystem-ui-react47.js";
import { CardContext as u } from "./designsystem-ui-react64.js";
function p({
  src: t,
  alt: o = "",
  aspectRatio: s = "5/4",
  className: l,
  children: n,
  responsive: m = !0
}) {
  const { isLink: c, direction: a } = d(u), f = {
    square: "1/1",
    video: "16/9",
    "1/1": "1/1",
    "5/4": "5/4",
    "4/3": "4/3",
    "3/2": "3/2",
    "16/9": "16/9"
  };
  let e;
  return a === "vertical" ? e = ["flex-shrink-0", "w-full"] : a === "horizontal" ? e = ["flex-shrink-0", "w-1/2", "aspect-square"] : m && (e = ["w-full", "aspect-square", "@md:w-1/2", "@md:aspect-video"]), /* @__PURE__ */ r(
    "div",
    {
      className: i("relative overflow-hidden", e, l),
      style: { aspectRatio: f[s] },
      children: t ? /* @__PURE__ */ r(
        "img",
        {
          alt: o,
          className: i(
            "size-full absolute inset-0 object-cover",
            c && "group-hover:scale-105 transition-transform duration-300"
          ),
          src: t
        }
      ) : n
    }
  );
}
p.displayName = "CardImage";
export {
  p as CardImage
};
